(function() {
  var modal = document.getElementById('install-modal');
  var openBtn = document.getElementById('install-open');
  if (!modal || !openBtn) return;

  var overlay = modal.querySelector('.install-modal__overlay');
  var closeBtns = modal.querySelectorAll('[data-close-modal]');

  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    trapFocus();
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    releaseFocus();
  }

  openBtn.addEventListener('click', openModal);
  overlay && overlay.addEventListener('click', closeModal);
  closeBtns.forEach(function(btn){ btn.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeModal(); });

  // Focus trapping (simple)
  var lastFocused;
  function trapFocus() {
    lastFocused = document.activeElement;
    var focusables = modal.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (focusables.length) focusables[0].focus();
  }
  function releaseFocus() {
    if (lastFocused) lastFocused.focus();
  }

  // Optional: progressive enhancement for Add to Cart inside modal
  document.querySelectorAll('form[data-install-atc]').forEach(function(form){
    form.addEventListener('submit', function(ev){
      // If theme already handles AJAX cart, skip custom handler
      if (form.hasAttribute('data-no-ajax')) return;
      ev.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept':'application/json' }})
        .then(function(r){ return r.json(); })
        .then(function(){
          // Basic toast
          var toast = document.createElement('div');
          toast.textContent = 'Added to cart';
          toast.style.position = 'fixed';
          toast.style.bottom = '20px';
          toast.style.left = '50%';
          toast.style.transform = 'translateX(-50%)';
          toast.style.padding = '10px 14px';
          toast.style.background = '#111';
          toast.style.color = '#fff';
          toast.style.borderRadius = '8px';
          toast.style.zIndex = '10000';
          document.body.appendChild(toast);
          setTimeout(function(){ toast.remove(); }, 1400);
        })
        .catch(function(){
          // Fallback: normal submit if AJAX fails
          form.removeAttribute('data-install-atc');
          form.submit();
        });
    });
  });
})();